import React from "react";
import cx from "classnames";

const Message = ({
  children,
  className,
  processing,
  info,
  fail,
  notice,
  success,
  ...props
}) => (
  <div
    className={cx(
      "message-bar p-4 font-normal rounded",
      {
        processing,
        success,
        notice,
        info,
        fail,
      },
      className
    )}
    {...props}
  >
    <span className="message-bar-msg">{children}</span>
  </div>
);

export default Message;
